module.exports = __webpack_public_path__ + "img/027-queen.05c76343.png";